// src/components/SplashScreen.js
import React, { useEffect } from "react";

function SplashScreen({ onFinish }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish(); // Tell App.js to hide splash screen
    }, 3000); // Matches the animation duration

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-background">
      {/* Logo */}
      <img
        src="/mtclogo.svg"
        alt="Moving The Chainz Logo"
        className="w-72 h-72 mb-6" // Bigger logo
      />

      {/* Progress Bar Container */}
      <div className="relative w-4/5 max-w-xl h-8 bg-secondary rounded-full overflow-hidden">
        {/* Car icon moving */}
        <div className="absolute bottom-0 w-16 h-auto animate-car-move">
          <img
            src="/car-icon.svg"
            alt="Loading car"
            // *** IMPORTANT CHANGE HERE ***
            // Ensure no flip and add will-change for rendering consistency
            className="w-10 h-10 transform scale-x-100 will-change-transform"
          />
        </div>

        {/* Progress bar filling */}
        <div className="h-full bg-primary animate-progress-bar" />
      </div>
    </div>
  );
}

export default SplashScreen;